"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutOffers = void 0;
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("./components");
var _constants = require("./constants");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file -- container
const CheckoutOffers = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.StrictMode, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
            logger: _logger2.mainLogger,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
                areaName: "".concat(_constants.APP_NAME, "-boundary"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
                    fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.OfferStepSkeleton, {}),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
                        team: _testidGenerator.Team.Checkout,
                        project: _constants.APP_NAME,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                            namespace: _constants.translationsNamespace,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.ThemeProvider, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.OfferStep, {})
                            })
                        })
                    })
                })
            })
        })
    });
exports.CheckoutOffers = CheckoutOffers;
